import { useEffect, useState } from 'react'

import { fetchOutcomeFreeSpinGameIds } from 'modules/SlotsRoot/utils/outcomeFreeSpin'

export const useOutcomeFreeSpinGameIds = (enabled: boolean) => {
  const [outcomeFreeSpinGameIds, setOutcomeFreeSpinGameIds] = useState<Set<string> | null>(null)
  const [isLoading, setIsLoading] = useState(enabled)

  useEffect(() => {
    if (!enabled) {
      setOutcomeFreeSpinGameIds(null)
      setIsLoading(false)
      return undefined
    }

    let isCancelled = false

    setIsLoading(true)

    fetchOutcomeFreeSpinGameIds()
      .then(ids => {
        if (!isCancelled) {
          setOutcomeFreeSpinGameIds(ids)
          setIsLoading(false)
        }
      })
      .catch(() => {
        if (!isCancelled) {
          setOutcomeFreeSpinGameIds(new Set())
          setIsLoading(false)
        }
      })

    return () => {
      isCancelled = true
    }
  }, [enabled])

  return { outcomeFreeSpinGameIds, isOutcomeFreeSpinLoading: isLoading }
}
